export default {
  title01: "Tiempo actual",
  title02: "24 horas",
  title03: "Ver pronóstico de 10 días",
  title04: "ICA",
  title05: "Ver toda la información",
  title06: "Amanecer y atardecer",
  title07: "Fase de la luna",
  title08: "Próxima luna llena",
  title09: "Próxima luna nueva",
  title10: "Día",
  title11: "Noche",
  title12: "Amanecer",
  title13: "Atardecer",
  title14: "Salida de la Luna",
  title15: "Puesta de la Luna",
  title16: "Fuente",
  title17: "Inicio",
  title18: "Fin",
  title19: "Usar ubicación real",
  title20: "Buscar la ciudad",
  title21: "Sensación",
  title22: "Temperatura real (sombra)",
  title23: "AHORA",
  title24: "HOY",
  title25: "SOL",
  title26: "LUN",
  title27: "MAR",
  title28: "MIÉ",
  title29: "JUE",
  title30: "VIE",
  title31: "SAB",
  title32: "Cargando",
  title33: "Ahora",
  title34: "Cada hora",
  title35: "Diariamente",
  title36: "Sol y Luna",
  title37: "Calidad del aire",
  title38: 'Contacto": xlf550402@gmail.com',
  title39: "Aceptación de privacidad",
  title40: "Derechos de autor© comfortweather.com 2020 - 2026. All Rights Reserved.",
  title41: "Datos proporcionados por",
  title42: "Hola",
  title43: "Lo",
  title44: "Aceptar",
  title45: "Gracias por usar ComfortWeather! Para proteger mejor tu privacidad: profavor lea atentamente la ",
  title46: "Politica de privacidad",
  title47: " antes de utilizarla",
  title48: "",
  title49: "Contacto: xyjph123@gmail.com",
  title50: "Derechos  ©24hweather.com 2020 - 2026. Todos los derechos reservados.",
  title51: "Gracias por usar ComfortWeather! Para proteger mejor  sus derechos e intereses legales, profavor lea el ",
  title52: "Tu ubicación ha cambiado. ¿Quieres actualizarla?",
  title53: "Confirmar",
  title54: "Cancelar",
  title55: "Atrás",
  title56: "Noticias",
  title57: "Actualizando el tiempo",
  title58: "Tiempo actualizado",
  title59: "Ver todos",
  title60: "Derechos  ©mobi321.com 2020 - 2026. Todos los derechos reservados.",
  title61: "Ayer",
  title62: "Mañana",
  title63: "Ver pronóstico de 15 días",
  title64: "Detalles de hoy",
  title65: "Rahu Kaal",
  title66: "Índices de estilo de vida",
  title67: "Índices de estilo de vida",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Difícil de secar",
  title103: "Se seca lentamente",
  title104: "Buen secado",
  title105: "Secado rápido",
  title106: "Secado muy rápido",

  title107: "No se recomienda",
  title108: "Condiciones aceptables",
  title109: "Ideal para actividades de agua",
  title110: "Muy recomendable",
  title111: "Condiciones perfectas",

  title112: "Favorece la salud",
  title113: "Condiciones normales",
  title114: "Riesgo ligeramente elevado",
  title115: "Riesgo alto",
  title116: "Riesgo muy alto",

  title117: "No se recomienda",
  title118: "Parcialmente recomendable",
  title119: "Ideal para actividades al aire libre",
  title120: "Muy recomendable",
  title121: "Condiciones excelentes",

  title122: "Condiciones de piel muy seca",
  title123: "Piel probablemente seca",
  title124: "Piel ligeramente seca",
  title125: "Piel poco probable seca",
  title126: "Piel muy poco probable seca",

  title127: "No se recomienda",
  title128: "Aceptable",
  title129: "Buen día",
  title130: "Muy buenas condiciones",
  title131: "Condiciones ideales",
};
